import { withQueryClientContext } from '../../../../../app/shared/components/QueryClientContext'
import { useETFHoldingsQuery } from '../hooks'
import { BreakdownView } from './BreakdownView'
import { TopTenView } from './TopTenView'

export const ETFHoldings = withQueryClientContext(() => {
  const query = useETFHoldingsQuery()

  return (
    <div className="relative -ml-3 flex flex-wrap justify-center">
      <BreakdownView query={query} />
      <TopTenView query={query} />
    </div>
  )
})
